"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fetchZap_1 = require("./fetchZap");
Object.defineProperty(exports, "fetchZap", { enumerable: true, get: function () { return fetchZap_1.default; } });
